<template>
  <div v-if="data" class="flex flex-col">
    <TeacherTitleSlug
      v-if="false"
      :title="data.title"
      :highlight-title="highlight.title"
      :highlight-paragraph="highlightParagraph"
      :link-for-back="`/teacher/${$route.params.parent}/${$route.params.category}?content=${data.model_type}${groupList}`"
    />
    <div class="grid grid-cols-1 gap-5 lg:grid-cols-3 xl:grid-cols-4">
      <div
        class="xl:max-w-full flex size-full flex-col lg:col-span-2 xl:col-span-3"
      >
        <TeacherThematicAccordeon
          v-if="false"
          :title="`Тематические лекции (${sortedCollection?.length})`"
          :data="sortedCollection"
          :current-active="activeIndex"
        />
        <TeacherNavigationMob
          class="mb-7 lg:hidden"
          :content-list="contentList"
          :current-active="currentActiveTocItem"
          @on-active="handleActiveTocItem"
        />

        <div
          class="flex justify-between text-[14px] leading-[18px] text-new-black-light"
        >
          <div class="flex items-center px-4 py-2">
            <SvgIcon
              name="bookmark"
              class="mr-2 size-4 cursor-pointer"
              :class="{ 'text-ruby-red-100': localIsBookmarked }"
              @click="handleBookmark()"
            ></SvgIcon>
            <div>В закладки</div>
          </div>
          <div
            v-if="getTimeForModel(data.model_type, data)"
            class="flex items-center px-4 py-2 text-[14px] font-medium leading-[24px]"
          >
            <SvgIcon name="clock" class="size-4" />
            <span class="ml-1">{{
              getTimeForModel(data.model_type, data)
            }}</span>
          </div>

          <!-- ВРЕМЕННО СКРЫТО -->
          <template v-if="false">
            <div
              v-if="data.authors?.length"
              class="ml-auto flex w-fit items-center uppercase"
            >
              <div class="author font-roboto font-bold">
                {{ data.authors[0].fullname }}
              </div>
            </div>
          </template>
          <!-- <div class="flex items-center py-2 px-4">
            {{
              new Date(data?.published_at).toLocaleString('ru-RU', {
                day: 'numeric',
                month: 'long',
                hour: 'numeric',
                minute: 'numeric',
              })
            }}
          </div> -->
        </div>

        <div
          ref="pageBodyRef"
          class="page-body scroll-margin-title mb-10"
          v-html="data.body"
        />
        <div class="mb-10 flex flex-wrap justify-center sm:justify-start">
          <div
            class="mb-2 mr-2 flex items-center px-4 py-2 text-[14px] font-medium leading-[17px]"
          >
            <SvgIcon
              name="eye-n"
              class="mr-2 size-4 text-new-card--title-black"
            ></SvgIcon>
            {{ data.views ?? 0 }}
          </div>

          <BaseTheReaction
            :key="data.id"
            :article-id="String(data.id)"
            :article-reactions="{
              reaction_discussion: data?.reaction_discussion,
              reaction_fire: data?.reaction_fire,
              reaction_like: data?.reaction_like,
              reaction_suddenly: data?.reaction_suddenly,
              reaction_think: data?.reaction_think,
              reaction_dont_like: data?.reaction_dont_like,
            }"
          />

          <!-- ВРЕМЕННО СКРЫТО -->
          <div
            v-if="false"
            class="flex cursor-default select-none items-center px-4 py-2 text-[14px] font-medium leading-[17px]"
          >
            <SvgIcon
              name="like-n"
              class="mr-2 size-4 cursor-pointer"
              :class="[
                localIsLiked
                  ? 'text-ruby-red-100'
                  : 'text-new-card--title-black',
              ]"
              @click="handleLike"
            ></SvgIcon>
            Мне нравится
          </div>
          <CommonSocialsSocialSharingRedisign class="w-fit sm:ml-auto" />
        </div>

        <div
          v-if="sortedCollection.length && sortedCollection.length > 1"
          class="hidden lg:flex"
        >
          <BaseTheButtonNew
            is-small
            icon="chevron-left"
            icon-position="left"
            text="Предыдущий материал"
            class="mr-4"
            :disabled="!activeIndex"
            @click="
              handleNavigate(
                `/teacher/${$route.params.parent}/${
                  $route.params.category
                }/article/${sortedCollection[activeIndex - 1]?.slug}`,
              )
            "
          />
          <BaseTheButtonNew
            is-small
            icon="chevron-right"
            text="Следующий материал"
            :disabled="sortedCollection.length - 1 === activeIndex"
            @click="
              handleNavigate(
                `/teacher/${$route.params.parent}/${
                  $route.params.category
                }/article/${sortedCollection[activeIndex + 1]?.slug}`,
              )
            "
          />
        </div>
      </div>
      <TeacherSideContentList
        :content-list="contentList"
        :current-active="currentActiveTocItem"
        :authors="data.authors"
        @on-active="handleActiveTocItem"
      />
    </div>
  </div>
</template>

<script setup>
import api from '@/services/api/api';

definePageMeta({
  layout: 'marginless',
});

const crumbsStore = useBreadcrumbsStore();

const props = defineProps({
  collection: {
    type: Array,
    default: () => [],
  },
  highlight: {
    type: Object,
    default: () => ({}),
  },
  category: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:collection']);

const route = useRoute();
const router = useRouter();
const toast = useToast();
const authStore = useAuthStore();
const { getTimeForModel } = useTimeForModel();

const slug = route?.params?.slug;
const { articleSlug } = useArticleBySlug(slug);

const contentList = ref([]);
const nodeListBody = ref([]);
const currentActiveTocItem = ref(0);
const localIsLiked = ref(false);
const localIsBookmarked = ref(false);
const pageBodyRef = ref(null);

/**computed */
const data = computed(() => articleSlug?.data?.value);

const groupList = computed(() => {
  if (!route?.query?.group) return '';
  return `&group=${route.query.group}`;
});

const highlightParagraph = computed(() => {
  let highlightIdx;
  props.category.chapters.find((item) =>
    item.highlights.find((highlight) => {
      if (highlight.id !== props.highlight.id) return '';
      highlightIdx = highlight.number;
      return highlight;
    }),
  );
  return highlightIdx ? `§ ${highlightIdx}.` : '';
});

const sortedCollection = computed(() => {
  return props.collection?.filter((item) => {
    return item.model_type === 'article';
  });
});

const activeIndex = computed(() => {
  return sortedCollection.value.findIndex(
    (item) => item.slug === data.value?.slug,
  );
});

/**watch */
watch(
  () => data.value?.body,
  () => {
    nextTick().then(() => {
      initRefBody();
      !sortedCollection.value?.length && fetch();
    });
  },
  {
    immediate: true,
  },
);

watch(
  () => activeIndex.value,
  async () => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    if (pageBodyRef.value) {
      pageBodyRef.value.scrollIntoView({
        behavior: 'smooth',
      });
    }
  },
);

/**mounted */
onMounted(() => {
  renderImageFooter(pageBodyRef.value);

  if (authStore.isAuthorized) {
    localIsLiked.value = data.value?.has_like;
    localIsBookmarked.value = data.value?.has_bookmark;
  } else {
    const userLikesString = localStorage.getItem('likes');
    const userLikesParsed = JSON.parse(userLikesString) || [];
    localIsLiked.value = userLikesParsed.includes(data.value?.id);
  }
});

/**methods */
const fetch = async () => {
  if (props.collection?.length === 0) {
    try {
      const slug = route.params.category;
      const { data: collection } =
        await api.collections.getCollectionItemsBySlug(slug, 'article');
      emit('update:collection', collection?.data ?? []);
    } catch (e) {
      console.log(e);
    }
  }
};

const handleNavigate = (path) => {
  router.push(path);
};

const initRefBody = () => {
  if (pageBodyRef.value) {
    renderImageFooter(pageBodyRef.value);
    nodeListBody.value = pageBodyRef.value?.querySelectorAll('h2') || [];

    const visibility = [];
    const observer = new IntersectionObserver(
      (entries) => {
        entries?.forEach((entry) => {
          if (entry.isIntersecting) {
            // const i = [...this.nodeListBody]?.findIndex(
            //   (node) => node === entry.target
            // )
            visibility.push(entry.target);
          } else {
            visibility.shift(entry.target);
          }

          const i = [...nodeListBody.value]?.findIndex(
            (node) => node === visibility[0],
          );

          currentActiveTocItem.value = i;
        });
      },
      {
        threshold: 0.5,
      },
    );

    contentList.value = [...nodeListBody.value]?.map((node, index) => {
      observer.observe(node);
      return {
        title: node.textContent,
        id: index,
      };
    });
  }
};

const handleActiveTocItem = (idx) => {
  currentActiveTocItem.value = idx;
  nodeListBody.value[idx].scrollIntoView({
    behavior: 'smooth',
  });
};

const handleLike = async () => {
  const userLikesString = localStorage.getItem('likes');
  // в результате JSON.parse получаем массив id лайкнутых пользователем сущностей
  const userLikesParsed = JSON.parse(userLikesString) || [];
  const isLiked = userLikesParsed.indexOf(data.value?.id) + 1;

  const like = async () => {
    try {
      await api.socials.handleLike({
        model_type: data.value?.model_type,
        id: data.value?.id,
      });

      if (!userLikesString) {
        localStorage.setItem('likes', JSON.stringify([data.value?.id]));
      } else if (!isLiked) {
        userLikesParsed.push(data.value?.id);
        localStorage.setItem('likes', JSON.stringify(userLikesParsed));
      }

      localIsLiked.value = true;
    } catch (e) {
      console.log(e);
    }
  };

  const dislike = async () => {
    try {
      await api.socials.handleDisLike({
        model_type: data.value?.model_type,
        id: data.value?.id,
      });
      if (userLikesString && isLiked) {
        userLikesParsed.splice(isLiked - 1, 1);
        localStorage.setItem('likes', JSON.stringify(userLikesParsed));
      }

      localIsLiked.value = false;
    } catch (e) {
      console.log(e);
    }
  };

  localIsLiked.value ? await dislike() : await like();
};

const handleBookmark = async () => {
  try {
    const { data: bookmark } = await api.socials.handleBookmark({
      model_type: data.value?.model_type,
      id: data.value?.id,
    });
    if (
      bookmark.err &&
      bookmark.err === 'You are not authorized or there are no such user'
    ) {
      toast.error('Необходимо авторизоваться!');
      return;
    }
    if (bookmark === 'Ok') {
      toast.success('Добавлено в избранное!');
    }
    if (bookmark === 'Deleted') {
      toast.success('Удалено из избранного!');
    }
    localIsBookmarked.value = !localIsBookmarked.value;
  } catch (e) {
    toast.error(`${e}`);
  }
};

watch(
  data,
  (val) => {
    if (!val) return;
    crumbsStore.setCrumbs({
      key: 'slug',
      value: {
        title: data.value?.title,
        slug: data.value?.slug,
      },
    });
  },
  { immediate: true },
);

onBeforeRouteLeave(() => {
  crumbsStore.setCrumbs({ key: 'slug', value: null });
});

useHead(
  computed(() => ({
    title: `${
      data.value?.title ? `${data.value.title} |` : ''
    } Материалы по истории для школьного курса «История России» и «Всеобщая история» с 5 по 11 класс`,
    meta: [
      {
        name: 'description',
        content:
          'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
      },
      {
        name: 'keywords',
        content: 'История РФ: статьи для школьников и студентов',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: data.value?.canonical_url || `https://histrf.ru/read/articles/${data.value?.slug}` || `https://histrf.ru${route.path}`,
      },
    ],
  })),
);
</script>

<style lang="scss" scoped>
.author {
  padding-left: 20px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: #a10009;
    left: 0;
    top: 50%;
    transform: translateY(-60%);
  }
}
.highlight {
  -webkit-tap-highlight-color: #0000;
}
</style>
